//import Swiper from "@theme/swiper";

class SwiperElement extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.slidesPerView = this.dataset.desktopColumn;
        this.spaceBetween = this.dataset.columnGap;
        this.spaceBetweenMobile = Number(this.dataset.columnGap) / 2;
        this.centeredSlides = this.dataset?.centeredSlides || false;
        this.init();
    }

    init() {
        const swiper = this.querySelector(".swiper");
        if (swiper) {
            new Swiper(swiper, {
                slidesPerView: this.centeredSlides ? 'auto' : 1,
                spaceBetween: !this.centeredSlides ? this.spaceBetweenMobile : 0,
                centeredSlides: this.centeredSlides,
                loop: this.centeredSlides,
                pagination: {
                    el: swiper.querySelector('.swiper-pagination'),
                    clickable: false,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    750: {
                        slidesPerView: this.slidesPerView,
                        spaceBetween: this.spaceBetween,
                        centeredSlides: false,
                    }
                }
            });
        }
    }
}
if (!customElements.get('swiper-element')) {
    customElements.define('swiper-element', SwiperElement);
}